import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-featured-projects"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (!$options.isTablet)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.chunks, (chunk) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(chunk.component), _mergeProps({
            key: chunk.projectID
          }, { ref_for: true }, chunk), null, 16 /* FULL_PROPS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : (_openBlock(), _createBlock(_resolveDynamicComponent($options.firstChunk.component), _mergeProps({ key: 1 }, $options.firstChunk, { class: "gfu-featured-projects" }), null, 16 /* FULL_PROPS */))
}